import { Theme, css } from '@emotion/react';

export const radioStyles = ({ colors, borderRadius, interactiveStates }: Theme) => css`
  color: ${colors.borderDark};

  input[type='radio'] {
    ${interactiveStates.focus(`
      & + svg {
        outline: 2px solid ${colors.borderPrimaryBase};
        outline-offset: 1px;
        border-radius: ${borderRadius.Pill};
      }
    `)}
  }
`;
